import { useEffect } from "react";
import { applyBranding } from "@/utils/branding";

// Applies tenant white-label branding (title, favicon, theme color) to the document.
export function BrandingApplier({ branding, name }) {
  useEffect(() => {
    applyBranding(branding, name);
  }, [branding, name]);
  return null;
}
